<!--
* @Name：报价信息对比明细详情
* @Author:王超
* @Date: 2021-12-02 16:13:46
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 16:13:46
-->
<template>
  <van-dialog
    class="attachment-dialog"
    :value="detailsVisible"
    title="报价信息"
    show-cancel-button
    cancel-button-text="关闭"
    cancel-button-color="#1989fa"
    :show-confirm-button="false"
    @cancel="close"
  >
    <div class="details-container">
      <hi-card v-for="(rankInfo, index) in rankInfoList" :key="rankInfo.quoteInfoPk" :row-index="index + 1">
        <van-row>
          <span>报价公司名称：</span>
          <span>{{ rankInfo.suppName }}</span>
        </van-row>
        <van-row>
          <span>最终报价：</span>
          <span>{{ rankInfo.unitPrice }}</span>
        </van-row>
        <van-row>
          <span>税率(%)：</span>
          <span>{{ rankInfo.taxRate }}</span>
        </van-row>
        <van-row v-if="computedStepPrice">
          <van-button type="info" size="normal" style="margin-bottom: 5px" @click="clickPriceList(rankInfo)"
            >阶梯价格设定</van-button
          >
        </van-row>
      </hi-card>
      <stage-price-info
        v-if="priceDialogVisible"
        :details-visible="priceDialogVisible"
        :price-list="priceListItem"
        @close-details-dialog="priceDialogVisible = false"
      />
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'EnquiryDetailInfo',
  components: {
    'stage-price-info': () => import('./StagePriceInfo')
  },
  data() {
    return {
      priceListItem: [],
      priceDialogVisible: false
    }
  },
  props: {
    rankInfoList: {
      type: Array,
      default: () => []
    },
    detailsVisible: {
      type: Boolean,
      default: false
    },
    showStepPrice: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedStepPrice() {
      return this.showStepPrice
    }
  },
  methods: {
    close() {
      this.$emit('close-details-dialog')
    },
    clickPriceList(rankInfo) {
      this.priceListItem = rankInfo.quoteStepPriceDTOList
      this.priceDialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.details-container {
  height: 500px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 20px;
}
</style>
